/** Consistent feedback while a route chunk loads, including slow/offline visits. */
export function RoutePending(): React.ReactElement {
  return (
    <div role="status" aria-live="polite" className="flex min-h-48 items-center justify-center gap-3 text-sm text-muted-foreground">
      <span aria-hidden="true" className="h-5 w-5 animate-spin rounded-full border-2 border-muted border-t-primary" />
      Loading page…
    </div>
  );
}

/** A failed dynamic import stays failed until a fresh document loads its assets. */
export function RouteError(): React.ReactElement {
  return (
    <div role="alert" className="mx-auto flex max-w-md flex-col items-center gap-3 px-6 py-16 text-center">
      <h1 className="text-xl font-semibold text-foreground">This page couldn’t load</h1>
      <p className="text-sm text-muted-foreground">Check your connection and reload to try again.</p>
      <button type="button" onClick={() => window.location.reload()} className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground">
        Reload page
      </button>
      <a href="/" className="text-sm text-primary underline">Go to your queue</a>
    </div>
  );
}
